module.exports = __webpack_public_path__ + "img/vu_malampa_flag.f4146fc8.svg";